// import React from "react";
// import "../App.css";
// import { Link } from "react-router-dom";

// function Service() {
//   return (
//     <div className="">
//       <div className="container-fluid services al py-1">
//         <div className="container text-center py-5">
//           <div className="text-center mb-5 wow fadeInUp" data-wow-delay=".3s">
//             <h5 className="mb-2 px-3 py-1 text-dark rounded-pill d-inline-block border border-2 border-primary">
//               CAD Desk Kaniyapuram
//             </h5>
//             <h1 className="display-5">Courses</h1>
//           </div>

//           <div className="row py-1 g-5">
            
//             {/* Civil & Architecture */}
//             <div
//               className="service bg-light col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
//               data-wow-delay=".3s"
//             >
//               <div className="rounded p-5 services-item">
//                 <div
//                   className="d-flex"
//                   style={{ alignItems: "center", justifyContent: "center" }}
//                 >
//                   <div className="mb-4 rounded-circle services-inner-icon">
//                     <i className="fas fa-drafting-compass fa-3x text-primary"></i>
//                   </div>
//                 </div>
//                 <h4 className="text-center">Civil & Architecture</h4>
//                 <p className="text-center fs-5">
//                   Comprehensive training in AutoCAD, Revit, SketchUp and 3Ds Max
//                   for building design, drafting and modeling.
//                 </p>
//                 <Link to="/Courses">
//                   <button
//                     type="button"
//                     className="btn btn-primary border-0 rounded-pill px-4 py-3"
//                   >
//                     Learn More
//                   </button>
//                 </Link>
//               </div>
//             </div>

//             {/* BIM */}
//             <div
//               className="service col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
//               data-wow-delay=".5s"
//             >
//               <div className="bg-light rounded p-5 services-item">
//                 <div
//                   className="d-flex"
//                   style={{ alignItems: "center", justifyContent: "center" }}
//                 >
//                   <div className="mb-4 rounded-circle services-inner-icon">
//                     <i className="fas fa-project-diagram fa-3x text-primary"></i>
//                   </div>
//                 </div>
//                 <h4 className="text-center">
//                   BIM (Building Information Modeling)
//                 </h4>
//                 <p className="text-center fs-5">
// BIM training with Revit Architecture, Structure & MEP and practical 3D modeling.                </p>
//                 <Link to="/civil-architecture">
//                   <button
//                     type="button"
//                     className="btn btn-primary border-0 rounded-pill px-4 py-3"
//                   >
//                     Learn More
//                   </button>
//                 </Link>
//               </div>
//             </div>

//             {/* Interior Designing */}
//             <div
//               className="service col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
//               data-wow-delay=".9s"
//             >
//               <div className="bg-light rounded p-5 services-item">
//                 <div
//                   className="d-flex"
//                   style={{ alignItems: "center", justifyContent: "center" }}
//                 >
//                   <div className="mb-4 rounded-circle services-inner-icon">
//                     <i className="fas fa-couch fa-3x text-primary"></i>
//                   </div>
//                 </div>
//                 <h4 className="text-center">Interior Designing</h4>
//                 <p className="text-center fs-5">
//                   Interior design training with AutoCAD, SketchUp, 3ds Max, V-Ray & Lumion for 2D drafting and 3D visualization
//                 </p>
//                 <Link to="/civil-design">
//                   <button
//                     type="button"
//                     className="btn btn-primary border-0 rounded-pill px-4 py-3"
//                   >
//                     Learn More
//                   </button>
//                 </Link>
//               </div>
//             </div>

//             {/* Mechanical Design */}
//             <div
//               className="service col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
//               data-wow-delay=".9s"
//             >
//               <div className="bg-light rounded p-5 services-item">
//                 <div
//                   className="d-flex"
//                   style={{ alignItems: "center", justifyContent: "center" }}
//                 >
//                   <div className="mb-4 rounded-circle services-inner-icon">
//                     <i className="fas fa-cogs fa-3x text-primary"></i>
//                   </div>
//                 </div>
//                 <h4 className="text-center">Mechanical Design</h4>
//                 <p className="text-center fs-5">
//                   Professional training in SolidWorks, CATIA and advanced
//                   mechanical modeling tools.
//                 </p>
//                 <Link to="/Courses">
//                   <button
//                     type="button"
//                     className="btn btn-primary border-0 rounded-pill px-4 py-3"
//                   >
//                     Learn More
//                   </button>
//                 </Link>
//               </div>
//             </div>

//           </div>

//           <Link to="/Courses">
//             <button
//               type="button"
//               className="btn btn-primary border-0 rounded-pill px-4 py-3 mt-4 wow fadeInUp"
//               data-wow-delay=".3s"
//             >
//               More Courses
//             </button>
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Service;




import React from "react";
import "../App.css";
import { Link, useNavigate } from "react-router-dom";

function Service() {
  const navigate = useNavigate();

  const goToCoursesTab = (tabId) => {
    navigate("/Courses", { state: { activeTabId: tabId } });
  };

  return (
    <div className="">
      <div className="container-fluid services al py-1">
        <div className="container text-center py-5">
          <div className="text-center mb-5 wow fadeInUp" data-wow-delay=".3s">
            <h5 className="mb-2 px-3 py-1 text-dark rounded-pill d-inline-block border border-2 border-primary">
              CAD Desk Kaniyapuram
            </h5>
            <h1 className="display-5">Courses</h1>
          </div>

          <div className="row py-1 g-5">

            {/* Civil & Architecture */}
            <div
              className="service bg-light col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
              data-wow-delay=".3s"
            >
              <div className="rounded p-5 services-item">
                <div className="d-flex" style={{ alignItems: "center", justifyContent: "center" }}>
                  <div className="mb-4 rounded-circle services-inner-icon">
                    <i className="fas fa-drafting-compass fa-3x text-primary"></i>
                  </div>
                </div>
                <h4 className="text-center">Civil & Architecture</h4>
                <p className="text-center fs-5">
Civil & Architecture CAD uses software like AutoCAD for 2D drawings and Autodesk Revit for 3D models to design buildings accurately for real construction projects.</p>                <button
                  type="button"
                  className="btn btn-primary border-0 rounded-pill px-4 py-3"
                  onClick={() => goToCoursesTab("CIVIL & ARCHITECTURE CAD")}
                >
                  Learn More
                </button>
              </div>
            </div>

            {/* BIM */}
            <div
              className="service col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
              data-wow-delay=".5s"
            >
              <div className="bg-light rounded p-5 services-item">
                <div className="d-flex" style={{ alignItems: "center", justifyContent: "center" }}>
                  <div className="mb-4 rounded-circle services-inner-icon">
                    <i className="fas fa-project-diagram fa-3x text-primary"></i>
                  </div>
                </div>
                <h4 className="text-center">BIM (Building Information Modeling)</h4>
                <p className="text-center fs-5">
BIM (Building Information Modeling) is a modern method of designing buildings using a smart 3D model that connects all elements, so any change updates related drawings automatically.</p>                <Link to="/civil-architecture"
                  type="button"
                  className="btn btn-primary border-0 rounded-pill px-4 py-3"
                  
                >
                  Learn More
                </Link>
              </div>
            </div>

            {/* Interior Designing */}
            <div
              className="service col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
              data-wow-delay=".9s"
            >
              <div className="bg-light rounded p-5 services-item">
                <div className="d-flex" style={{ alignItems: "center", justifyContent: "center" }}>
                  <div className="mb-4 rounded-circle services-inner-icon">
                    <i className="fas fa-couch fa-3x text-primary"></i>
                  </div>
                </div>
                <h4 className="text-center">Interior Designing</h4>
                <p className="text-center fs-5">
Interior Designing plans indoor spaces to be functional, comfortable, and visually appealing, using AutoCAD for 2D planning and SketchUp or Lumion for 3D visualization effectively.          </p>
                <Link to="/civil-design"
                  type="button"
                  className="btn btn-primary border-0 rounded-pill px-4 py-3"
                  onClick={() => goToCoursesTab("INTERIOR & BIM")}
                >
                  Learn More
                </Link>
              </div>
            </div>

            {/* Mechanical Design */}
            <div
              className="service col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
              data-wow-delay=".9s"
            >
              <div className="bg-light rounded p-5 services-item">
                <div className="d-flex" style={{ alignItems: "center", justifyContent: "center" }}>
                  <div className="mb-4 rounded-circle services-inner-icon">
                    <i className="fas fa-cogs fa-3x text-primary"></i>
                  </div>
                </div>
                <h4 className="text-center">Mechanical Design</h4>
                <p className="text-center fs-5">
Mechanical Design creates machines, tools, and components using engineering principles, designing gears, shafts, engines, and assemblies, using AutoCAD for 2D and SolidWorks or CATIA for 3D modeling.                       </p>
                <button
                  type="button"
                  className="btn btn-primary border-0 rounded-pill px-4 py-3"
                  onClick={() => goToCoursesTab("MECHANICAL CAD")}
                >
                  Learn More
                </button>
              </div>
            </div>

          </div>

          <button
            type="button"
            className="btn btn-primary border-0 rounded-pill px-4 py-3 mt-4 wow fadeInUp"
            data-wow-delay=".3s"
            onClick={() => navigate("/Courses")}
          >
            More Courses
          </button>
        </div>
      </div>
    </div>
  );
}

export default Service;